import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import type { FetchResult, MutationResult } from '@apollo/client';

import { showErrorAction, showMessageAction } from 'containers/Notification/actions';
import { useUpsertChallengeMutation, ChallengeUpsertInputType } from 'generated/graphql';

export const useChallengeMutation = (
  challengeId?: string
): [(data: ChallengeUpsertInputType) => void, MutationResult] => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCompleted: Exclude<
    Parameters<typeof useUpsertChallengeMutation>[0],
    undefined
  >['onCompleted'] = (result) => {
    dispatch(
      showMessageAction(
        challengeId ? 'Challenge updated successfully' : 'Challenge created successfully'
      )
    );

    const effectiveChallengeId = result?.upsertChallenge?.id || challengeId;
    if (effectiveChallengeId) {
      history.push(`/challenges/${effectiveChallengeId}`);
    } else {
      history.push('/challenges');
    }
  };

  const onError = () => {
    dispatch(
      showErrorAction(
        `An error occurred while ${
          challengeId ? 'updating' : 'creating'
        } your challenge, please try again`
      )
    );
  };

  const [upsertChallengeMutation, result] = useUpsertChallengeMutation({
    onCompleted,
    onError,
  });

  const mutation = (data: ChallengeUpsertInputType): Promise<FetchResult> =>
    upsertChallengeMutation({
      variables: { data },
    });

  return [mutation, result];
};
